import(/* webpackMode: "eager", webpackExports: ["SightsPanel"] */ "/app/src/app/sights/SightsPanel.tsx");
